<template>
  <section class="component-header clearfix section-area">
    <div class="container" ref="head">
      <div class="layout-g-w1200">
        <div class="logo fl">
          <a to="/">
            <!-- <img :src="logo" alt="首页" /> -->
             <img src="@/assets/img/headerLeft.jpg" alt="" class="headerLeft">
             <div></div>
             <img src="@/assets/img/headerRight.jpg" alt="" class="headerRight"> 
          </a>
        </div>
        <header class="links">
          <a href="https://www.innohall.cn/">首页</a>
          <a href="https://www.innohall.cn/products">创新服务Mall</a>
          <a href="https://www.innohall.cn/bigenterprises">产业对接</a>
          <a href="https://www.innohall.cn/spaces">创新空间</a>
          <a href="https://www.innohall.cn/talent">人才服务</a>
          <a href="https://www.innohall.cn/policyService">政策匹配</a>
          <a href="https://www.innohall.cn/activities">创新活动</a>
          <a href="https://www.innohall.cn/reservation">预约服务</a>
        </header>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-header",
  data() {
    return {
      timer: null
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollFn, false);
  },
  watch: {
  },
  computed: {

  },
  methods: {
    scrollFn() {
      clearTimeout(this.timer);
      let Dhead = this.$refs.head;
      this.timer = setTimeout(function () {
        let sTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let gap = 0;
        let className = Dhead.className;
        if (sTop > gap && className.indexOf("shadow") == -1) {
          Dhead.className = className + " shadow";
        } else if (sTop <= gap && className.indexOf("shadow") > -1) {
          Dhead.className = 'container'
        }
      }, 20);
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollFn, false);
  },
};
</script>

<style lang="scss">
.layout-g-w1200 {
  display: flex;
  width: 1200px;
  margin: 0 auto;
}
.el-dropdown-menu.user-dropdown {
  width: 120px;
  text-align: center;
  .el-dropdown-menu__item {
    padding: 0;
  }
  a,
  span {
    display: inline-block;
    width: 100%;
    color: #666;
  }
  .fa-sign-out {
    font-size: 16px;
    margin-left: 10px;
  }
}

.component-header {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #dcdcdc;
  background-color: #fff;

  .container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    z-index: 19;
    height: 80px;
    min-width: 1200px;
    background: #fff;
  }

  .container,
  .logo,
  .logo img,
  .links a,
  .center {
    -webkit-transition: all 0.25s;
    -moz-transition: all 0.25s;
    -ms-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
  }

  .center {
    padding-top: 24px;
    padding-right: 10px;

    .userName {
      color: #999;
      font-size: 14px;
      line-height: 32px;
      cursor: pointer;

      span {
        display: inline-block;
        max-width: 100px;
        vertical-align: top;
        overflow: hidden;
        white-space: nowrap;
        word-break: keep-all;
        -ms-text-overflow: ellipsis;
        text-overflow: ellipsis;
      }

      a {
        color: #183db0;
      }
    }

    .logout {
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
      cursor: pointer;
    }
  }

  .shadow {
    position: fixed;
    height: 60px;
    line-height: 60px;
    -webkit-box-shadow: 0 3px 5px #ccc;
    -moz-box-shadow: 0 3px 5px #ccc;
    box-shadow: 0 3px 5px #ccc;
    border-bottom: 1px solid #dcdcdc;

    .logo {
      padding-top: 0px;
    }

    .links {
      line-height: 61px;
      height: 60px;
    }

    .center {
      padding-top: 0;
    }

    .userName {
      line-height: 60px;
      cursor: pointer;
    }

    .logout {
      line-height: 60px;
    }
  }

  .logo {
    height: 100%;
    margin-right: 20px;
    margin-left: 10px;
    padding-top: 10px;
    a{
      display: flex;
      align-items: center;
      width: 230px;
      height: 55px;
      justify-content: space-evenly;
    }
   .headerLeft{
      width: 60px;
      // height: 100%;
    }
    div{
      width: 1px;
      height: 100%;
      background: #cccccc;
    }
    .headerRight{
      width: 120px;
      // height: 100%;
    }
  }

  .links {
    display: inline-block;
    line-height: 80px;
    text-align: center;
    font-size: 0;
    vertical-align: top;

    a {
      text-decoration: none;
      display: inline-block;
      padding: 0 25px;
      font-size: 16px;
      color: #bcbcbc;
      vertical-align: top;
    }

    .active,
    a:hover {
      background-color: #183db0;
      color: #fff;
    }
  }
  .ui-g-btn {
    display: inline-block;
    height: 30px;
    padding: 0 23px;
    border: 1px solid #183db0;
    line-height: 30px;
    color: #183db0;
    border-radius: 4px;
    cursor: pointer;
    transition: .25s ease-in;

    &.active, &:hover {
      background: #183db0;
      color: #fff;
    }
  }
}
</style>
